import groq from 'groq';

export const SEO = groq`
  seo {
    title,
    description,
    image,
  }
`;
